export default __webpack_public_path__ + "static/media/sub-app-easy-sign-logo.92a819d847973fbafaa9a8a0ffaa01a5.webp";